import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(components)/Application/Nft/NftActivityDescription/NftActivityDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(components)/Application/User/UserLink/UserLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(components)/Basic/Date/Date.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(components)/Basic/EndemicUserWrapper/EndemicUserWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(components)/Basic/Icon/ThemedIcon.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/arbitrum.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/coinbase.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/ethereum.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/metamask.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/polygon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/turbo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icons/walletConnect.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/images/artworkPlaceholder.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/web3/connectors/coinbase.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/web3/connectors/metaMask.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/web3/connectors/walletConnect.ts");
